import React, { Component } from 'react';
import { Button, Image, Modal } from 'react-bootstrap';
import '../../content/css/ExportDocumentModal.css';

var img = require("../../content/images/legly_on_ipad.jpg");

export default class BecomeCustomerModal extends Component {

    handleButtonClick = () => {
        window.location.href = 'https://www.legly.io/pricing/monthly-subscription';
    }

    render() {
        return (
            <Modal className="limited-offer-modal" show={this.props.show} onHide={this.props.onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Subscribe</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div>
                            <h2>Subscribe today and get:</h2>
                            <h4>Unlimited reviews</h4>
                            <p>Upload and review all the documents you want, as many times as you want.</p>
                            <h4>Free contract review guidelines</h4>
                            <p>Get access to all guidelines. Ask us if you want to customize them yourself.</p>
                            <h4>Get started for just $5 - use code: LEGLY5</h4>
                            <p>Experience all the benefits for only $5 monthly for the first three months*. Use code LEGLY5 to sign up today!</p>
                            <p>*After three months the full plan continues automatically at $39/month - cancel anytime.</p>
                        </div>
                        <div>
                            <Image src={img} thumbnail responsive />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.handleButtonClick}>Claim this offer now</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Misc/BecomeCustomerModal.js